import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

const GradingBoxQuestion = ({ updateComponentPointsEarned, updateComponentScoreStatus, pointsEarned, uuid, updateUseCustomScoreFromGrading }) => {
    const [pointsEarnedInit, setPointsEarnedInit] = useState(Number(pointsEarned).toFixed(2));
    const [pointsEarnedDynamic, setPointsEarnedDynamic] = useState(Number(pointsEarned).toFixed(2));
    const { courseCode, assessmentCode, email } = useParams();

    const handleChange = (e) => {
        setPointsEarnedDynamic(e.target.value);
    }

    const submitForm = async () => {
        if (Number(pointsEarnedDynamic).toFixed(2) === Number(pointsEarnedInit).toFixed(2)) {
            return;
        }        

        try {
            const url = process.env.REACT_APP_SUBMISSION_API_URL + "/update-points-earned";

            const urlOptions = {
                method: "POST",
                credentials: "include",
                headers: {
                    'Content-Type': "application/json"
                },
                body: JSON.stringify({
                    courseCode: courseCode,
                    assessmentCode: assessmentCode,
                    email: email,
                    pointsEarned: pointsEarnedDynamic,
                    uuid: uuid
                })
            }

            const response = await fetch(url, urlOptions);
            const data = await response.json();
            if (response.status === 200) {
                const points = parseFloat(data.pointsEarned);

                if (Number.isNaN(points) || Number.isNaN(pointsEarnedInit)) {
                    return;
                }

                updateComponentPointsEarned(points);
                setPointsEarnedInit(points);
                setPointsEarnedDynamic(points);
                updateUseCustomScoreFromGrading(true);

                if (updateComponentScoreStatus) {
                    updateComponentScoreStatus(false);
                }

            } else if (response.status === 401) {
                window.location.href = process.env.REACT_APP_401_REDIRECT_URL;
            } else {
                alert("Status Code: " + response.status + " Error: " + data.detail);
            }
        } catch (error) {
            alert("Error: " + error.message)
            console.log(error)
        }
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            if (pointsEarnedDynamic !== pointsEarnedInit) {
                submitForm();
            }
        }, 1000)

        return () => {
            clearTimeout(timer);
        };

    }, [pointsEarnedDynamic])

    useEffect(() => {
        if (pointsEarned >= 0) {
            setPointsEarnedInit(Number(pointsEarned).toFixed(2));
            setPointsEarnedDynamic(Number(pointsEarned).toFixed(2));
        }

    }, [pointsEarned])

    return (
        <>
            <input onBlur={submitForm} className="grading-box-question" type="text" value={pointsEarnedDynamic} onChange={handleChange}/>
        </>
    );
}

export default GradingBoxQuestion;